import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["selectable", "isSelected", "isHighlighted", "children"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { alpha } from 'utils/ui';
import { borderValue } from 'styles/mixins';
import TabIndexContext from 'components/TabIndexContext';
import { withTableContext, tableContextPropFilter } from './TableContext';
import { getBreakpoint } from '../utils';
var Tr = withTableContext(styled.tr.withConfig({
  shouldForwardProp: tableContextPropFilter
}).withConfig({
  displayName: "TableRow__Tr",
  componentId: "sc-x48l91-0"
})(["vertical-align:", ";tbody &:not([aria-selected]):hover{background-color:", ";}tbody &:not([aria-selected]):focus-within{background-color:", ";}&[aria-selected]{cursor:pointer;}tbody:hover &[data-highlighted]{outline:1px solid ", ";outline-offset:-1px;background-color:", ";}tbody &[data-highlighted]:focus-within{outline:1px solid ", ";outline-offset:-1px;background-color:", ";}tbody &[aria-selected=\"true\"],tbody &[aria-selected=\"true\"][data-highlighted]{background-color:", "};}@media (max-width:", "){position:relative;display:flex;flex-direction:column;padding-bottom:", ";border-bottom:", ";}"], function (p) {
  return p.align || 'inherit';
}, function (p) {
  return alpha(p.theme.shade, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return alpha(p.theme.shade, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return p.theme.links;
}, function (p) {
  return alpha(p.theme.links, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return p.theme.links;
}, function (p) {
  return alpha(p.theme.links, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return alpha(p.theme.links, Math.max(0.15, +p.theme.shadeStrength));
}, getBreakpoint('mobileViewBreakpoint'), function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return borderValue(p.theme);
}));
var TableRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var selectable = _ref.selectable,
    isSelected = _ref.isSelected,
    isHighlighted = _ref.isHighlighted,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TabIndexContext, {
    disabled: Boolean(selectable && !isHighlighted)
  }, /*#__PURE__*/React.createElement(Tr, _extends({}, otherProps, {
    ref: ref,
    "aria-selected": selectable ? isSelected : undefined,
    "data-highlighted": selectable && isHighlighted || null
  }), children));
});
TableRow.displayName = 'TableRow';
export default TableRow;